export default __webpack_public_path__ + "static/media/plus.c6d7fd9c.svg";